import type { BulkAddSkipReason, SpaceRole } from '@lens/shared';

/** Подписи, общие для вкладки участников и окна выдачи доступа. */

export const ROLE_LABEL: Record<SpaceRole, string> = {
  admin: 'Администратор',
  member: 'Участник',
  viewer: 'Наблюдатель',
};

export const SKIP_REASON_LABEL: Record<BulkAddSkipReason, string> = {
  already_member: 'уже в пространстве',
  user_not_found: 'пользователь не найден',
  user_disabled: 'выключен в Keycloak',
  keycloak_unavailable: 'Keycloak недоступен',
};
